// https://stackoverflow.com/a/20732091/6322008
export const formatFileSize = (size: number) => {
    const i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1000));
    return (
        Number((size / Math.pow(1000, i)).toFixed(2)) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i]
    );
};
